import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

const GEO_URL = "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/australia.geojson";

const REGIONS = [
    { code: "Australian Capital Territory", name: "Australian Capital Territory" },
    { code: "New South Wales", name: "New South Wales" },
    { code: "Northern Territory", name: "Northern Territory" },
    { code: "Queensland", name: "Queensland" },
    { code: "South Australia", name: "South Australia" },
    { code: "Tasmania", name: "Tasmania" },
    { code: "Victoria", name: "Victoria" },
    { code: "Western Australia", name: "Western Australia" },
];

const REGION_CODES = REGIONS.map(r => r.code);
const ITEMS = REGIONS.map(r => ({ id: r.code, name: r.name }));

const AustraliaMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{ scale: 700, center: [134, -28] }}
            width={800}
            height={600}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => REGION_CODES.includes(geo.properties.name))
                        .map((geo) => {
                            const code = geo.properties.name;
                            const isVisited = visited.includes(code);
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(code)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="australia"
            analyticsLocationType="australia"
            trackingLabel="Australia Map"
            storageKey="australia_map"
            title="🇦🇺 Australia Travel Map"
            subtitle="Click on Australian states and territories you've visited. Or use the checklist below!"
            items={ITEMS}
            noun="States"
            unitLabel="states and territories"
            captionUnit="Australian states and territories"
            share={{
                region: 'Australia',
                fileName: 'visited-australia-map.png',
                trackId: 'australia'
            }}
            renderMap={renderMap}
        />
    );
};

export default AustraliaMapSection;
